import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  TablePagination,
  CircularProgress,
  Modal,
  Typography,
  Box,
} from "@mui/material";
import * as XLSX from "xlsx";
import { Version } from "../../api/api";
import {
  setEncryptedItem,
  getDecryptedItem,
  removeItem,
} from "../../utils/storageUtils";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MuiHeader from "../../components/MuiHeader";
import {
  createPrakasak,
  deletePrakasak,
  getPrakasak,
  updatePrakashakData,
  getPrakasakDataHistory,
} from "./prakasak.Thunk";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import {
  getUserAppSession,
  postSyncAppSessionThunk,
  updateSyncAppSessionThunk,
} from "../login/Login.Thunk";
import { logout } from "../login/Login.Slice";
import { v4 as uuidv4 } from "uuid";
import Spinner from "../../components/Spinner";
import UndoIcon from "@mui/icons-material/Undo";
import { UploadFileToAzureDB, deleteFileFromDB } from "../../components/Azure";
import pako from "pako";
import { Buffer } from "buffer";

const Prakashak = () => {
  const dispatch = useDispatch();
  const [years, setYears] = useState([2024, 2025]);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [jsonData, setJsonData] = useState([]);
  const [jsonTable, setJsonTable] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [editingIndices, setEditingIndices] = useState([]);
  const [file, setFile] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [studentData, setStudentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [convertLoading, setConvertLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [listLoading, setListLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [searchname, setSearchname] = useState("");
  const [searchStudent, setSearchStudent] = useState(null);
  const [uploadHistory, setUploadHistory] = useState([]);
  const [isDragOver, setIsDragOver] = useState(false);
  const [duplicateParam, setDuplicateParam] = useState("");
  const [findDuplicates, setFindDuplicates] = useState([]);
  const [clas, setClas] = useState("");
  const [page, setPage] = useState(0);
  const [uploadFile, setUploadFile] = useState("");
  const [fileName, setFileName] = useState("");
  const rowsPerPage = 100;
  const [updateData, setUpdateData] = useState({
    student_name: "",
    class: "",
    gender: "",
    parents_name: "",
    phone_number: "",
    block: "",
    cluster: "",
    district: "",
    school_name: "",
    student_id: "",
    udise_code: "",
    whatsapp_user: "",
    parents_id: "",
  });

  //----------------for session------------------------
  const sessionCalled = useRef(false);
  const userType = getDecryptedItem("usertype");
  const userName = getDecryptedItem("username");
  let userId = getDecryptedItem("userid");
  let uniqueId = getDecryptedItem("uniqueId");

  if (!uniqueId) {
    uniqueId = uuidv4();
    setEncryptedItem("uniqueId", uniqueId);
    // localStorage.setItem("uniqueId", uniqueId);
  }
  const [alertShown, setAlertShown] = useState(false);

  console.log(`duplicate param---->${duplicateParam}  and class----> ${clas}`);

  const handleClassChange = (e) => {
    if (duplicateParam && duplicateParam === "class") {
      setClas(e.target.value);
      const duplicates = studentData?.filter(
        (item) => item.class === e.target.value
      );
      console.log("duplicates----------->", duplicates);
      setFindDuplicates(duplicates);
    }
  };

  const fetchData = async () => {
    try {
      if (!sessionCalled.current) {
        sessionCalled.current = true;
        const body = {
          userid: userId,
          username: userName,
          usertype: userType,
          lastUsed: new Date(),
          deviceId: uniqueId,
          app: "mis",
          appVersion: Version?.version,
        };
        console.log("data---->", body);
        const response = await dispatch(postSyncAppSessionThunk(body));
        console.log("sessionresponse--->", response, response.status);
        if (
          response?.payload?.status === 200 ||
          response?.payload?.status === 201
        ) {
          const userAppSessionResponse = await dispatch(
            getUserAppSession({
              app: body.app,
              usertype: body.usertype,
              userId: userId,
              deviceId: uniqueId,
            })
          );
          console.log("get response--->", userAppSessionResponse);
          if (
            userAppSessionResponse.payload.data[0]?.logout === true &&
            !alertShown
          ) {
            setAlertShown(true);
            alert("Your session has ended. Please log in again.");
            const updateBody = {
              userid: userId,
              app: "mis",
              appVersion: Version?.version,
            };
            console.log("body", updateBody);
            const updateResponse = await updateSyncAppSessionThunk(updateBody);
            console.log("updateLogoutSession response:", updateResponse);
            dispatch(logout());
          } else {
            console.log("get response fail--->", userAppSessionResponse);
          }
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const openUpdateModalOnClick = (item) => {
    console.log("item----------->", item);
    setOpenUpdateModal(true);
    setUpdateData({
      student_name: item.student_name,
      class: item.class,
      gender: item.gender,
      parents_name: item.parents_name,
      phone_number:
        !item.phone_number || item.phone_number === "NA"
          ? "NA"
          : item.phone_number.length === 10
          ? "91" + item.phone_number.toString()
          : item.phone_number,
      block: item.block,
      cluster: item.cluster,
      district: item.district,
      school_name: item.school_name,
      student_id: item.student_id,
      udise_code: item.udise_code,
      whatsapp_user: item.whatsapp_user,
      parents_id: item.parents_id,
    });
  };

  const closeUpdateModalOnClick = () => {
    setOpenUpdateModal(false);
    setUpdateData({
      student_name: "",
      class: "",
      gender: "",
      parents_name: "",
      phone_number: "",
      block: "",
      cluster: "",
      district: "",
      school_name: "",
      student_id: "",
      udise_code: "",
      whatsapp_user: "",
      parents_id: "",
    });
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleNameOnSearch = (event) => {
    const searchValue = event.target.value.trim();
    setSearchname(searchValue);

    // Escape special characters for regex
    const escapedSearchValue = escapeRegExp(searchValue);
    const regex = new RegExp(escapedSearchValue, "i"); // 'i' flag for case-insensitive search

    // Filter studentData based on the search value
    const matchingObjects = studentData.filter((student) => {
      return regex.test(student.student_name);
    });

    setSearchStudent(matchingObjects);
  };

  const handleUpdateData = () => {
    if (updateData?.student_name.trim() === "" || !updateData.student_name) {
      toast.error("Please add the student's name !");
    } else if (!updateData.class) {
      toast.error("Please add the student's class !");
    } else if (!updateData.gender) {
      toast.error("Please add the student's gender !");
    } else if (
      updateData?.parents_name.trim() === "" ||
      !updateData.parents_name
    ) {
      toast.error("Please add the student's parent's name !");
    }
    // else if (
    //   !updateData.parents_whatsapp_number ||
    //   (updateData.parents_whatsapp_number !== "NA" &&
    //     !/^(\d{10})?$/.test(updateData.parents_whatsapp_number))
    // ) {
    //   toast.error("Please add a valid WhatsApp number or enter NA!");
    // }
    else if (
      !updateData.phone_number ||
      (updateData.phone_number !== "NA" &&
        !/^(\d{12})?$/.test(updateData.phone_number))
    ) {
      toast.error("Please add a valid phone number or enter NA!");
    } else {
      setUpdateLoading(true);
      console.log("body sent for Update---->", updateData);
      updatePrakashakData(updateData)
        .then((res) => {
          if (res.status === 200) {
            toast.success("Successfully updated !", {
              style: {
                backgroundColor: "#585858",
                color: "white",
                borderRadius: "40px",
              },
            });
            setUpdateData({
              student_name: "",
              class: "",
              gender: "",
              parents_name: "",
              phone_number: "",
              parents_whatsapp_number: "",
              block: "",
              cluster: "",
              school_name: "",
            });
            setUpdateLoading(false);
            setOpenUpdateModal(false);
            getPrakasak({ year: selectedYear })
              .then((res) => {
                if (res.status === 200) {
                  setStudentData(res.data);
                  setLoading(false);
                  // Reload the window after successful data fetch
                  window.location.reload();
                } else {
                  console.log("response status--->", res.status);
                  setLoading(false);
                  setUpdateLoading(false);
                }
              })
              .catch((error) => {
                setLoading(false);
                console.error("Error fetching data:", error);
                if (error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("An unexpected error occurred:", error);
                  toast.error(
                    "An unexpected error occurred. Please try again later."
                  );
                }
                setUpdateLoading(false);
              });
          } else {
            console.log("The status got ----> ", res.status);
            toast.error("Sorry, couldn't update this time ☹");
          }
        })
        .catch((err) => {
          console.error(`The error received : ${err}`);
          setUpdateLoading(false);
          toast.error("Sorry, something went wrong 😖", {
            style: {
              backgroundColor: "black",
              color: "orange",
              borderRadius: "40px",
            },
          });
        });
    }
  };

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  const requiredColumns = [
    "student_name",
    "parents_name",
    "gender",
    "student_id",
    "class",
    "phone_number",
    "school_name",
    "udise_code",
    "district",
    "block",
    "cluster",
  ];

  const select_option_list = [
    { value: "remoteInstruction", text: "Remote Instruction" },
    { value: "whatsappChatbot", text: "WhatsApp Chabot" },
    { value: "schoolWise", text: "School-wise" },
    { value: "classWise", text: "Class-wise" },
  ];

  const genderList = [
    { value: "male", text: "Male" },
    { value: "female", text: "Female" },
  ];

  const classList = [
    { value: 1, text: "1" },
    { value: 2, text: "2" },
    { value: 3, text: "3" },
    { value: 4, text: "4" },
    { value: 5, text: "5" },
  ];

  const hiddenColumns = ["parents_id", "regd_date", "regd_time"];

  const handleFileInputChange = (e) => {
    setStudentData([]);
    const selectedFile = e.target.files[0];
    if (
      selectedFile &&
      selectedFile?.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      const timestamp = new Date().getTime();
      const originalName = selectedFile.name.split(".").slice(0, -1).join(".");
      const fileExtension = selectedFile.name.split(".").pop();
      const uniqueFileName = `${originalName}_${timestamp}.${fileExtension}`;
      setFileName(uniqueFileName);
      setFile(selectedFile);
      handleConvertFile(selectedFile);
    } else {
      alert("Invalid file type. Please select an Excel file.");
    }
  };

  const handleConvertFile = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        handleConvert(e.target.result);
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };

      reader.readAsArrayBuffer(file);
    } else {
      setFile(null);
    }
  };

  const handleConvert = (data) => {
    setConvertLoading(true);
    setProgress(0);
    setTimeout(() => {
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      console.log("json", json);

      if (!json?.length) {
        alert("There are no records in this file.");
        setFile("");
        return;
      }

      const totalRows = json.length;
      let processedRows = 0;

      const interval = setInterval(() => {
        processedRows += Math.ceil(totalRows / 10);
        setProgress(
          Math.min(100, Math.round((processedRows / totalRows) * 100))
        );

        if (processedRows >= totalRows) {
          clearInterval(interval);

          const requiredColumnsPresent = requiredColumns.every((column) =>
            Object.keys(json[0]).includes(column)
          );

          if (!requiredColumnsPresent) {
            const missingColumns = requiredColumns.filter(
              (column) => !Object.keys(json[0]).includes(column)
            );
            alert(
              `Invalid file: Required columns are missing - ${missingColumns.join(
                ", "
              )}`
            );
            setFile("");
            return;
          }

          const missingDataRows = json.filter((row) =>
            requiredColumns.some(
              (column) =>
                row[column] === undefined ||
                (typeof row[column] === "string" && row[column].trim() === "")
            )
          );

          if (missingDataRows.length > 0) {
            const missingDataColumns = requiredColumns.filter((column) =>
              json.some(
                (row) =>
                  row[column] === undefined ||
                  (typeof row[column] === "string" && row[column].trim() === "")
              )
            );
            alert(
              `Invalid file: Some rows are missing data in required columns - Columns: ${missingDataColumns.join(
                ", "
              )}`
            );
            setFile("");
            setConvertLoading(false);
            return;
          }

          handleFileUpload(json);
          setConvertLoading(false);
        }
      }, 200);
    }, 100);
  };

  // const handleFileUpload = (json) => {
  //   console.log("handleFileUpload", json);
  //   const currentDate = new Date();
  //   const parentIdsMap = {};
  //   const studentIdsSet = new Set();

  //   const updatedJson = json?.reduce((acc, item, index) => {
  //     // Check for duplicate student_id
  //     if (item?.student_id && studentIdsSet.has(item.student_id)) {
  //       return acc; // Skip duplicate entry
  //     }
  //     studentIdsSet.add(item?.student_id); // Add unique student_id to Set

  //     let parent_id;
  //     const parentDetails = `${item.parents_name}-${item.phone_number}`;
  //     if (parentIdsMap[parentDetails]) {
  //       parent_id = parentIdsMap[parentDetails];
  //     } else {
  //       parent_id = `s${currentDate.getTime()}${Math.floor(
  //         Math.random() * 10000
  //       )}${index + 1}`;
  //       parentIdsMap[parentDetails] = parent_id;
  //     }

  //     const phone_number =
  //       item?.phone_number && item?.phone_number !== ""
  //         ? item?.phone_number.toString().startsWith("-1")
  //           ? "-1"
  //           : "91" + item?.phone_number.toString()
  //         : "";

  //     const udise_code =
  //       item?.udise_code !== undefined && item?.udise_code !== ""
  //         ? item?.udise_code.toString()
  //         : "";

  //     const defaultDate = currentDate.toISOString().split("T")[0];
  //     const defaultTime = "10:00";
  //     const date = item?.regd_date || defaultDate;
  //     const time = item?.regd_time == "-" ? defaultTime : defaultTime;

  //     acc.push({
  //       ...item,
  //       parents_id: parent_id,
  //       phone_number: phone_number,
  //       udise_code: udise_code,
  //       regd_date: date.replace(/^"|"$/g, ""),
  //       regd_time: time.replace(/^"|"$/g, ""),
  //     });

  //     return acc;
  //   }, []);

  //   console.log("updatedJson", updatedJson);
  //   setJsonTable(updatedJson);
  //   setJsonData(updatedJson);
  //   setEditingIndices([]);
  // };

  const handleFileUpload = (json) => {
    console.log("handleFileUpload", json);
    const currentDate = new Date();
    const parentIdsMap = {};

    const updatedJson = json?.map((item, index) => {
      // Generate unique parent ID
      let parent_id;
      const parentDetails = `${item.parents_name}-${item.phone_number}`;
      if (parentIdsMap[parentDetails]) {
        parent_id = parentIdsMap[parentDetails];
      } else {
        parent_id = `s${currentDate.getTime()}${Math.floor(
          Math.random() * 10000
        )}${index + 1}`;
        parentIdsMap[parentDetails] = parent_id;
      }

      // Function to replace empty string, "-1", and "NA" with null
      const sanitizeValue = (value) => {
        return value === "" || value === "-1" || value === -1 || value === "NA"
          ? null
          : value;
      };

      // Format phone number with country code
      const phone_number = sanitizeValue(item?.phone_number)
        ? "91" + item?.phone_number.toString()
        : null;

      // Format UDISE code
      const udise_code = sanitizeValue(item?.udise_code);

      // Set default date and time if not present
      const defaultDate = currentDate.toISOString().split("T")[0]; // Default date as current date
      const defaultTime = "10:00"; // Default time as "10:00"
      const date = sanitizeValue(item?.regd_date) || defaultDate;
      const time = sanitizeValue(item?.regd_time) || defaultTime;

      // Return updated object
      return {
        ...item,
        parents_id: parent_id,
        phone_number: phone_number,
        udise_code: udise_code,
        regd_date: date.replace(/^"|"$/g, ""),
        regd_time: time.replace(/^"|"$/g, ""),
        anganwadi_code: sanitizeValue(item?.anganwadi_code),
        anganwadi_name: sanitizeValue(item?.anganwadi_name),
        block: sanitizeValue(item?.block),
        class: sanitizeValue(item?.class),
        cluster: sanitizeValue(item?.cluster),
        district: sanitizeValue(item?.district),
        gender: sanitizeValue(item?.gender),
        parents_name: sanitizeValue(item?.parents_name),
        school_name: sanitizeValue(item?.school_name),
        sector: sanitizeValue(item?.sector),
        student_name: sanitizeValue(item?.student_name),
        whatsapp_user: sanitizeValue(item.whatsapp_user),
      };
    });

    console.log("updatedJson", updatedJson); // Log the updated JSON array to verify
    setJsonTable(updatedJson);
    setJsonData(updatedJson);
    setEditingIndices([]);
  };
  console.log("jsonTable", jsonTable);
  console.log("jsonData", jsonData);

  const handleSubmit = async () => {
    const uploadId = `upld_${new Date().getTime()}`;

    const submitConfirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit this record?",
      icon: "success",
      showCancelButton: true,
      confirmButtonColor: "blue",
      confirmButtonText: "Yes, submit it!",
    });

    if (submitConfirmation.isConfirmed) {
      setSaveLoading(true);

      // const updatedJsonData = jsonData.map((student) => ({
      //   ...student,
      //   uploadId,
      // }));
      const updatedJsonData = jsonData.map((student) => {
        // Remove empty fields dynamically
        const cleanedStudent = Object.fromEntries(
          Object.entries(student).filter(
            ([key, value]) => key.startsWith("__EMPTY") === false
          )
        );

        return {
          ...cleanedStudent,
          uploadId,
        };
      });
      // const compressedData = pako.deflate(JSON.stringify(updatedJsonData));
      // const base64Compressed = await btoa(
      //   compressedData.reduce(
      //     (acc, byte) => acc + String.fromCharCode(byte),
      //     ""
      //   )
      // );

      const body = {
        studentsArr: updatedJsonData,
      };

      console.log("Compressed body:", body);

      createPrakasak(body)
        .then((res) => {
          console.log("res", res);
          if (res.status === 200) {
            Swal.fire(
              "Success!",
              "Record has been successfully created.",
              "success"
            );
            setJsonTable("");
            setJsonData("");
            setFile("");
            setSaveLoading(false);
            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else if (res.status === 400) {
            Swal.fire("Error", res?.data?.msg, "error");
            setSaveLoading(false);
            setFile("");
          }
        })
        .catch((error) => {
          console.error("Create failed:", error);
          const errorMessage =
            error.response?.data?.err || "An unexpected error occurred.";
          Swal.fire("Error", errorMessage, "error");
          setSaveLoading(false);
          setFile("");
          setJsonTable("");
          setJsonData("");
        });
    }
  };

  const handleAllDataDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete All the record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      confirmButtonText: "Yes, delete it!",
    }).then(async (value) => {
      if (value.isConfirmed) {
        // Call your delete API with the studentId
        setDeleteLoading(true);
        const body = {
          studentsArr: studentData,
        };
        try {
          const response = await deletePrakasak(body);
          if (response.status === 200) {
            // Swal.fire({
            //   icon: "success",
            //   title: "Success",
            //   text: `${response?.data?.msg} of ${response?.data?.resp?.deletedCount} records`,
            // });
            alert("successfully Deleted");
            setDeleteLoading(false);
          } else {
            // Swal.fire({
            //   icon: "error",
            //   title: "Error",
            //   text: response.data.msg || "Failed to delete records!",
            // });
            alert("Failed to delete");
            setDeleteLoading(false);
          }
          setTimeout(() => {
            window.location.reload();
          }, 500);
          // console.log("delete", response);
        } catch (error) {
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
          console.error("Delete failed:", error);
          setDeleteLoading(false);
        }
      }
    });
  };

  // const handleDeleteIndividualData = (item) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to delete this record?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       const body = {
  //         studentsArr: [item],
  //       };
  //       console.log("body used to delete------->", body);
  //       try {
  //         const response = await deletePrakasak(body);
  //         if (response.status === 200) {
  //           toast.success(
  //             "Successfully deleted. You can still recover it before 12 AM !"
  //           );
  //           getPrakasak({ year: selectedYear })
  //             .then((res) => {
  //               if (res.status === 200) {
  //                 setStudentData(res.data);
  //                 setLoading(false);
  //               } else {
  //                 console.log("response status--->", res.status);
  //                 setLoading(false);
  //               }
  //             })
  //             .catch((error) => {
  //               setLoading(false);
  //               console.error("Error fetching data:", error);
  //               if (error.response.status === 500) {
  //                 toast.error("Internal server error.");
  //               } else if (error.response.status === 504) {
  //                 toast.error("Server timeout. Please try again later.");
  //               } else {
  //                 console.error("An unexpected error occurred:", error);
  //                 toast.error(
  //                   "An unexpected error occurred. Please try again later."
  //                 );
  //               }
  //             });
  //         } else {
  //           toast.error("Failed to delete. Please try again later !");
  //           console.log("response status----->", response.status);
  //         }
  //       } catch (err) {
  //         console.error("The error is--->", err);
  //         if (err.response.status === 500) {
  //           toast.error("Internal server error.");
  //         } else if (err.response.status === 504) {
  //           toast.error("Server timeout. Please try again later.");
  //         } else {
  //           console.error("An unexpected error occurred:", err);
  //           toast.error(
  //             "An unexpected error occurred. Please try again later."
  //           );
  //         }
  //       }
  //     }
  //   });
  // };

  // const handleEdit = () => {
  //   if (editingIndices.length === 0) {
  //     setEditingIndices([...Array(jsonTable.length).keys()]);
  //   } else {
  //     setEditingIndices([]);
  //   }
  // };

  const handleReset = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "All fields will be clear",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, reset it!",
    }).then((value) => {
      // console.log("alert", value);
      if (value.isConfirmed) {
        setJsonTable("");
        setJsonData("");
        setFile("");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    });
  };

  const handleCellChange = (rowIndex, key, value) => {
    // Update the jsonTable with the edited value
    const updatedJsonTable = [...jsonTable];
    updatedJsonTable[rowIndex][key] = value;
    setJsonTable(updatedJsonTable);
    setJsonData(updatedJsonTable);
    // setJsonData(JSON.stringify(updatedJsonTable, null, 2));
  };

  const renderEditableCell = (value, rowIndex, key) => {
    const isEditable = editingIndices.includes(rowIndex);
    const isHiddenColumn = hiddenColumns.includes(key);

    return (
      <td
        key={key}
        style={{
          padding: "10px",
          border: "1px solid #dddddd",
          display: isHiddenColumn ? "none" : "table-cell",
        }}
      >
        {isEditable ? (
          <TextField
            value={value}
            onChange={(e) => handleCellChange(rowIndex, key, e.target.value)}
          />
        ) : typeof value === "boolean" ? (
          value.toString()
        ) : (
          <span>{value}</span>
        )}
      </td>
    );
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    setFile(e.dataTransfer.files[0]);
    handleConvertFile(e.dataTransfer.files[0]);
  };

  const fetchPrakshakData = async () => {
    setLoading(true);
    setListLoading(true); // Start loading states at the beginning

    try {
      const res = await getPrakasak({ year: selectedYear });

      if (res.status === 200) {
        setStudentData(res.data);
      }
      // No need to handle 204 or 500 as they already end loading states.
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setListLoading(false); // End loading states in the finally block
    }
  };

  const fetchPrakshakDataHistory = async () => {
    setLoading(true);
    setListLoading(true); // Start loading states at the beginning

    try {
      const res = await getPrakasakDataHistory(); // Call the API

      if (res.status === 200) {
        setUploadHistory(res.data); // Handle successful response
      }
      // Optionally, handle other statuses (204, 500) if needed.
    } catch (error) {
      console.error("Error fetching data history:", error); // Log any errors
    } finally {
      setLoading(false); // End loading states
      setListLoading(false); // End loading states
    }
  };

  useEffect(() => {
    fetchPrakshakData();
    fetchPrakshakDataHistory();
  }, [selectedYear]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    if (!years.includes(currentYear)) {
      setYears([...years, currentYear]);
    }
  }, [years]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    setLoading(true);
    getPrakasak({
      year: event.target.value,
    })
      .then((res) => {
        if (res.status === 200) {
          setStudentData(res.data);
          setLoading(false);
        } else {
          console.log("response status--->", res.status);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const duplicateDataFetching = (e) => {
    if (e.target.value) {
      setDuplicateParam(e.target.value);
      setClas("");

      if (
        e.target.value === "parents_name" ||
        e.target.value === "parents_phone_number" ||
        e.target.value === "school_name" ||
        e.target.value === "cluster"
      ) {
        const param = e.target.value;

        const countMap = studentData.reduce((acc, student) => {
          const key = student[param];

          // Check if 'school_name' or 'cluster' has a name longer than 4 characters
          if (key && (param === "school_name" || param === "cluster")) {
            if (key.length > 4) {
              acc[key] = (acc[key] || 0) + 1;
            }
          } else if (key) {
            acc[key] = (acc[key] || 0) + 1;
          }

          return acc;
        }, {});

        const duplicates = studentData.filter(
          (student) => countMap[student[param]] > 1
        );

        setFindDuplicates(duplicates);
      } else {
        setFindDuplicates(studentData);
      }
    } else {
      setDuplicateParam("");
      setClas("");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <MuiHeader header="PRAKASAK (Student details)" />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex" }}>
          <FormControl
            sx={{ width: "130px" }}
            style={{ width: "130px", paddingRight: "10px" }}
            size="small"
          >
            <InputLabel id="year-select-label">Year</InputLabel>
            <Select
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Year"
            >
              {years?.length > 0 &&
                years?.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {!loading && studentData.length > 0 && !searchname ? (
            <FormControl
              sx={{ width: "100%" }}
              style={{ width: "180px", paddingRight: "10px" }}
              size="small"
            >
              <InputLabel id="duplicate-select-label">
                Find Duplicates
              </InputLabel>
              <Select
                labelId="duplicate-select-label"
                id="duplicate-select-label"
                value={duplicateParam}
                onChange={duplicateDataFetching}
                label="Find Duplicates"
              >
                <MenuItem value={null}>None</MenuItem>
                {duplicateTabs?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : null}

          {duplicateParam === "class" ? (
            <FormControl
              sx={{ width: "100%" }}
              style={{ width: "180px" }}
              size="small"
            >
              <InputLabel id="year-select-label">Choose Class</InputLabel>
              <Select
                labelId="class-select-label"
                id="class-select"
                value={clas}
                onChange={handleClassChange}
                label="Choose Class"
              >
                {classArray?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : null}
        </div>

        {deleteLoading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <Button
            onClick={handleAllDataDelete}
            variant="contained"
            style={{
              backgroundColor: "red",
              width: "150px",
              height: "50px",
              fontSize: "14px",
              padding: "8px 16px",
            }}
          >
            Delete All
          </Button>
        )}
      </div>

      <div style={{ display: "flex", width: "100%", gap: "20px" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "45%",
            padding: "20px",
            border: isDragOver ? "2px dashed #007AFF" : "2px dashed #ddd",
            borderRadius: "12px",
            backgroundColor: "#f7f9fc",
            alignItems: "center", // Center horizontally
            justifyContent: "center", // Center vertically
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            transition: "border-color 0.3s",
          }}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <label
            htmlFor="fileInput"
            style={{
              cursor: "pointer",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            <UploadFileIcon size={30} />
            <p style={{ margin: "10px 0", fontSize: "16px", color: "#333" }}>
              Drag & Drop or <br /> Click to Select File
            </p>
          </label>
          <input
            id="fileInput"
            type="file"
            accept=".xls,.xlsx"
            onChange={handleFileInputChange}
            style={{ display: "none" }}
          />
          {file &&
            file?.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && (
              <p
                style={{
                  margin: "10px 0",
                  textAlign: "center",
                  color: "#007AFF",
                }}
              >
                Selected File: <strong>{file.name}</strong>
              </p>
            )}
        </div>

        {/* Right Side: Data List */}
        <div
          style={{
            width: "55%",
            maxHeight: "350px",
            padding: "10px",
            paddingLeft: "20px",
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            backgroundColor: "#f7f8fc",
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h4
            style={{
              fontFamily: "Arial, sans-serif",
              color: "#333",
              marginBottom: "10px",
              fontSize: "20px",
            }}
          >
            Upload History
          </h4>
          {listLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Spinner onLoadComplete={() => setListLoading(false)} />
            </div>
          ) : (
            <div
              style={{
                maxHeight: "300px",
                overflowY: "auto",
                scrollbarWidth: "none", // For Firefox
              }}
              className="scroll-hide"
            >
              {uploadHistory.length === 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    color: "#555",
                    fontFamily: "Arial, sans-serif",
                    fontSize: "18px",
                  }}
                >
                  No Records
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#007AFF",
                    }}
                  >
                    <tr>
                      {[
                        "Date",
                        "Original",
                        "Unchanged",
                        "Added",
                        "Updated",
                        "Deleted",
                      ].map((header) => (
                        <th
                          key={header}
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontFamily: "Arial, sans-serif",
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px",
                            borderBottom: "1px solid #e0e0e0",
                          }}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {uploadHistory.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontFamily: "Arial, sans-serif",
                            color: "#555",
                            fontSize: "14px",
                          }}
                        >
                          {new Date(item.uploadedAt).toLocaleString("en-US", {
                            dateStyle: "medium",
                            timeStyle: "short",
                          })}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontFamily: "Arial, sans-serif",
                            color: "#555",
                            fontSize: "14px",
                          }}
                        >
                          {item.original}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontFamily: "Arial, sans-serif",
                            color: "#555",
                            fontSize: "14px",
                          }}
                        >
                          {item.unchanged}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontFamily: "Arial, sans-serif",
                            color: "#008080",
                            fontSize: "14px",
                          }}
                        >
                          {item.added}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontFamily: "Arial, sans-serif",
                            color: item.updated > 0 ? "#4CAF50" : "#555",
                            fontSize: "14px",
                            fontWeight: item.updated > 0 ? "bold" : "normal",
                          }}
                        >
                          {item.updated}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            textAlign: "left",
                            fontFamily: "Arial, sans-serif",
                            color: item.deleted > 0 ? "#FF0000" : "#555",
                            fontSize: "14px",
                            fontWeight: item.deleted > 0 ? "bold" : "normal",
                          }}
                        >
                          {item.deleted}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      </div>
      {studentData && studentData.length > 0 ? (
        <>
          <div style={{ marginTop: "20px" }}>
            <h3
              style={{
                fontFamily: "Roboto, sans-serif",
                paddingLeft: "10px",
              }}
            >
              Search Student Details
            </h3>

            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                id="outlined-multiline-static"
                label="Search by Student Name"
                multiline
                rows={2}
                variant="outlined"
                size="small"
                value={searchname}
                onChange={handleNameOnSearch}
                style={{
                  width: "100%",
                  height: "40px",
                  marginBottom: "20px",
                  padding: "8px 12px",
                  marginRight: "10px", // Adds some space between the input and the button
                }}
              />
              <Button
                variant="contained"
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px 16px",
                  height: "40px", // Matches the height of the TextField
                }}
              >
                <UndoIcon />
                <p style={{ margin: "0 5px" }}>Undo</p>
              </Button>
            </div>
          </div>
        </>
      ) : null}

      <>
        <div
          style={{
            marginTop: "20px",
            paddingBottom: "20px",
            display: "flex",
            flexDirection: "column",
            paddingLeft: "10px",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              {!searchStudent &&
              !duplicateParam &&
              studentData &&
              studentData.length > 0 ? (
                <span>Total {studentData?.length} Records Found</span>
              ) : duplicateParam && findDuplicates ? (
                <span>{findDuplicates?.length} Records Found</span>
              ) : duplicateParam && !findDuplicates ? (
                <span>{findDuplicates?.length} Records Found</span>
              ) : null}
            </div>
          </div>
        </div>

        {convertLoading ? (
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "35%",
              // transform: "translate(-50%, -50%)",
              background: "rgba(0, 0, 0, 0.8)",
              color: "white",
              padding: "20px",
              borderRadius: "5px",
              textAlign: "center",
              width: "300px",
            }}
          >
            <Typography variant="h6" sx={{ mb: 1 }}>
              Processing: {progress}%
            </Typography>
            <CircularProgress variant="determinate" value={progress} />
          </Box>
        ) : jsonTable && jsonTable?.length > 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginTop: "20px",
                paddingBottom: "20px",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            ></div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <Button
                onClick={handleReset}
                variant="contained"
                color="inherit"
                style={{ marginRight: "10px" }}
              >
                Reset
              </Button>
              {/* <Button
                onClick={handleEdit}
                variant="contained"
                color="inherit"
                style={{ marginRight: "10px" }}
              >
                Edit
              </Button> */}
              {saveLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "10px" }}
                >
                  Submit
                </Button>
              )}
            </div>
          </div>
        ) : null}
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : studentData &&
          studentData?.length > 0 &&
          !searchStudent &&
          !duplicateParam ? (
          <div
            style={{
              width: "100%",
            }}
          >
            {studentData && (
              <div
                style={{
                  height: "700px",
                  overflowY: "auto",
                }}
              >
                <table
                  style={{
                    minWidth: "800px",
                    width: "100%",
                    display: "table",
                  }}
                >
                  <thead
                    style={{
                      backgroundColor: "#f2f2f2",
                      position: "sticky",
                      top: "0",
                    }}
                  >
                    <tr>
                      <th
                        key="no"
                        style={{ border: "1px solid #dddddd", padding: "10px" }}
                      >
                        No Records
                      </th>
                      {studentData &&
                        studentData?.length > 0 &&
                        Object.keys(studentData[0])
                          .filter((key) => !hiddenColumns.includes(key))
                          .map((key) => (
                            <th
                              key={key}
                              style={{
                                border: "1px solid #dddddd",
                                padding: "10px",
                              }}
                            >
                              {key}
                            </th>
                          ))}
                    </tr>
                  </thead>

                  <tbody>
                    {studentData &&
                      studentData?.length > 0 &&
                      studentData
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            {Object.entries(row).map(([key, value], idx) =>
                              renderEditableCell(value, index, key)
                            )}
                            {/* <TableCell>
                              <div style={{ display: "flex", gap: 40 }}>
                                <EditIcon
                                  style={{ color: "blue", cursor: "pointer" }}
                                  onClick={() => openUpdateModalOnClick(row)}
                                />
                                <DeleteIcon
                                  style={{ color: "red", cursor: "pointer" }}
                                  onClick={() =>
                                    handleDeleteIndividualData(row)
                                  }
                                />
                              </div>
                            </TableCell> */}
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ) : searchStudent && searchStudent?.length > 0 ? (
          <div
            style={{
              width: "100%",
            }}
          >
            {searchStudent && (
              <div
                style={{
                  height: "700px",
                  overflowY: "auto",
                }}
              >
                <table
                  style={{
                    minWidth: "800px",
                    width: "100%",
                    display: "table",
                  }}
                >
                  <thead
                    style={{
                      backgroundColor: "#f2f2f2",
                      position: "sticky",
                      top: "0",
                    }}
                  >
                    <tr>
                      <th
                        key="no"
                        style={{ border: "1px solid #dddddd", padding: "10px" }}
                      >
                        No Records
                      </th>
                      {searchStudent &&
                        searchStudent?.length > 0 &&
                        Object.keys(searchStudent[0])
                          .filter((key) => !hiddenColumns.includes(key))
                          .map((key) => (
                            <th
                              key={key}
                              style={{
                                border: "1px solid #dddddd",
                                padding: "10px",
                              }}
                            >
                              {key}
                            </th>
                          ))}
                    </tr>
                  </thead>

                  <tbody>
                    {searchStudent &&
                      searchStudent?.length > 0 &&
                      searchStudent
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            {Object.entries(row).map(([key, value], idx) =>
                              renderEditableCell(value, index, key)
                            )}
                            {/* <TableCell>
                              <div style={{ display: "flex", gap: 40 }}>
                                <EditIcon
                                  style={{ color: "blue", cursor: "pointer" }}
                                  onClick={() => openUpdateModalOnClick(row)}
                                />
                                <DeleteIcon
                                  style={{ color: "red", cursor: "pointer" }}
                                  onClick={() =>
                                    handleDeleteIndividualData(row)
                                  }
                                />
                              </div>
                            </TableCell> */}
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ) : findDuplicates && findDuplicates?.length > 0 ? (
          <div
            style={{
              width: "100%",
            }}
          >
            {findDuplicates && (
              <div
                style={{
                  height: "700px",
                  overflowY: "auto",
                }}
              >
                <table
                  style={{
                    minWidth: "800px",
                    width: "100%",
                    display: "table",
                  }}
                >
                  <thead
                    style={{
                      backgroundColor: "#f2f2f2",
                      position: "sticky",
                      top: "0",
                    }}
                  >
                    <tr>
                      <th
                        key="no"
                        style={{ border: "1px solid #dddddd", padding: "10px" }}
                      >
                        No Records
                      </th>
                      {findDuplicates &&
                        findDuplicates?.length > 0 &&
                        Object.keys(findDuplicates[0])
                          .filter((key) => !hiddenColumns.includes(key))
                          .map((key) => (
                            <th
                              key={key}
                              style={{
                                border: "1px solid #dddddd",
                                padding: "10px",
                              }}
                            >
                              {key}
                            </th>
                          ))}
                    </tr>
                  </thead>

                  <tbody>
                    {findDuplicates &&
                      findDuplicates?.length > 0 &&
                      findDuplicates
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            {Object.entries(row).map(([key, value], idx) =>
                              renderEditableCell(value, index, key)
                            )}
                            {/* <TableCell>
                              <div style={{ display: "flex", gap: 40 }}>
                                <EditIcon
                                  style={{ color: "blue", cursor: "pointer" }}
                                  onClick={() => openUpdateModalOnClick(row)}
                                />
                                <DeleteIcon
                                  style={{ color: "red", cursor: "pointer" }}
                                  onClick={() =>
                                    handleDeleteIndividualData(row)
                                  }
                                />
                              </div>
                            </TableCell> */}
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ) : jsonTable && jsonTable?.length > 0 ? (
          <tbody>
            {jsonTable &&
              jsonTable?.length > 0 &&
              jsonTable
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    }}
                  >
                    <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                    {Object.entries(row).map(([key, value], idx) =>
                      renderEditableCell(value, index, key)
                    )}
                  </tr>
                ))}
          </tbody>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          ></div>
        )}
        {studentData && studentData.length > 0 && !searchStudent ? (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={() => setPage((prevPage) => Math.max(prevPage - 1, 0))}
              disabled={page === 0}
            >
              &lt;
            </Button>
            <span style={{ margin: "0 10px" }}>{page + 1}</span>
            <Button
              onClick={() =>
                setPage((prevPage) =>
                  Math.min(
                    prevPage + 1,
                    Math.ceil(studentData.length / rowsPerPage) - 1
                  )
                )
              }
              disabled={
                page === Math.ceil(studentData.length / rowsPerPage) - 1
              }
            >
              &gt;
            </Button>
          </div>
        ) : studentData && searchStudent && searchStudent.length > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={() => setPage((prevPage) => Math.max(prevPage - 1, 0))}
              disabled={page === 0}
            >
              &lt;
            </Button>
            <span style={{ margin: "0 10px" }}>{page + 1}</span>
            <Button
              onClick={() =>
                setPage((prevPage) =>
                  Math.min(
                    prevPage + 1,
                    Math.ceil(studentData.length / rowsPerPage) - 1
                  )
                )
              }
              disabled={
                page === Math.ceil(searchStudent.length / rowsPerPage) - 1
              }
            >
              &gt;
            </Button>
          </div>
        ) : null}
      </>
      <Modal open={openUpdateModal} onClose={closeUpdateModalOnClick}>
        <Box sx={style}>
          <TextField
            id="outlined-multiline-static"
            label="Student Name"
            multiline
            rows={2}
            variant="outlined"
            sx={{
              width: 250,
              marginTop: 2,
              marginLeft: 4,
            }}
            size="small"
            value={updateData?.student_name}
            onChange={(e) =>
              setUpdateData({ ...updateData, student_name: e.target.value })
            }
          />

          <FormControl
            sx={{ marginTop: 2, width: 250, marginLeft: 4 }}
            size="small"
          >
            <InputLabel id="demo-select-small">Class</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={updateData.class}
              label="Class"
              onChange={(e) => {
                setUpdateData({ ...updateData, class: e.target.value });
              }}
              style={{ padding: "3%" }}
            >
              {classList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl
            sx={{ marginTop: 2, width: 250, marginLeft: 4 }}
            size="small"
          >
            <InputLabel id="demo-select-small">Gender</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={updateData.gender}
              label="Gender"
              onChange={(e) => {
                setUpdateData({ ...updateData, gender: e.target.value });
              }}
              style={{ padding: "3%" }}
            >
              {genderList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            id="outlined-multiline-static"
            label="Parent's Name"
            multiline
            rows={2}
            variant="outlined"
            sx={{
              width: 250,
              marginTop: 2,
              marginLeft: 4,
            }}
            size="small"
            value={updateData?.parents_name}
            onChange={(e) =>
              setUpdateData({ ...updateData, parents_name: e.target.value })
            }
          />

          <TextField
            id="outlined-multiline-static"
            label="Parent's Phone number"
            multiline
            rows={2}
            variant="outlined"
            sx={{
              width: 250,
              marginTop: 2,
              marginLeft: 4,
            }}
            size="small"
            value={updateData?.phone_number}
            onChange={(e) => {
              let phoneNumber = e.target.value;
              phoneNumber = phoneNumber.replace(/\D/g, "");

              if (phoneNumber.length === 0) {
                phoneNumber = "NA";
              } else {
                if (!phoneNumber.startsWith("91")) {
                  phoneNumber = "91" + phoneNumber;
                }
                phoneNumber = phoneNumber.slice(0, 12);
              }

              setUpdateData({
                ...updateData,
                phone_number: phoneNumber,
              });
            }}
          />

          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Button
              variant="contained"
              sx={{
                width: 70,
                marginTop: 2,
                marginBottom: 1,
                marginRight: 1,
              }}
              onClick={closeUpdateModalOnClick}
            >
              Cancel
            </Button>
            {updateLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Button
                variant="contained"
                sx={{
                  width: 70,
                  marginTop: 2,
                  marginBottom: 1,
                  marginRight: 1,
                }}
                onClick={handleUpdateData}
                // disabled={loading}
              >
                Update
              </Button>
            )}
          </div>
        </Box>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default Prakashak;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const duplicateTabs = [
  {
    label: "Phone number",
    value: "parents_phone_number",
  },
  {
    label: "Parent's name",
    value: "parents_name",
  },
  {
    label: "Class",
    value: "class",
  },
  {
    label: "School",
    value: "school_name",
  },
  {
    label: "Cluster",
    value: "cluster",
  },
];

const classArray = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
];
